import { Grid, View, Card, useTheme } from '@aws-amplify/ui-react';
import { withAuthenticator, Button, Heading } from '@aws-amplify/ui-react';

import Toolbar from './Toolbar'
import NavBar from './NavBar';

export const DefaultGridExample = ({children}) => {
  const { tokens } = useTheme();
  return (
    <Grid
    columnGap="0.5rem"
    rowGap="1rem"
    templateColumns="1fr 1fr  1fr  1fr"
    templateRows="0fr 3fr 1fr"
  >
    <Card
      columnStart="1"
      columnEnd="-1"
      backgroundColor={'#ccc'}
      maxHeight={'150px'}
    >
      
      <Toolbar/>


    </Card>

    {/* <Card
      columnStart="1"
      columnEnd="2"
      backgroundColor={'#f4f4f4'}
    >
      <NavBar></NavBar>
    </Card> */}

    <Card
      columnStart="2"
      columnEnd="-1"
      maxHeight={'11145px'}
      
    >
             {children} 
    
             <div style = {{height:"50vh"}}> </div>

    </Card>
    <Card
      columnStart="1"
      columnEnd="-1"
      backgroundColor={'#ccc'}
      maxHeight={'45px'}
    >
     <sub>kitboga.net</sub> 
    </Card>
  </Grid>
  );
};

//export default withAuthenticator(DefaultGridExample);

export default DefaultGridExample;